import {useLayoutEffect, useState, type RefObject} from 'react';

export interface ElementSize {
    readonly width: number;
    readonly height: number;
}

const EMPTY: ElementSize = {width: 0, height: 0};

export const useElementSize = (ref: RefObject<HTMLElement | null>): ElementSize => {
    const [size, setSize] = useState<ElementSize>(EMPTY);

    useLayoutEffect(() => {
        const element = ref.current;
        const Observer = element?.ownerDocument.defaultView?.ResizeObserver;
        if (!element || !Observer) {
            return;
        }
        const measure = () => {
            const width = element.clientWidth;
            const height = element.clientHeight;
            setSize(current => (current.width === width && current.height === height ? current : {width, height}));
        };
        measure();
        const observer = new Observer(measure);
        observer.observe(element);
        return () => observer.disconnect();
    }, [ref]);

    return size;
};
